(function(){
  'use strict';
  var CART='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2.2l2.3 12.1a1.8 1.8 0 0 0 1.8 1.4h8.4a1.8 1.8 0 0 0 1.8-1.4L21 7H5.4"/></svg>';

  function prixCourant(){
    var box=document.querySelector('.product-price-container');
    if(!box)return '';
    var m=box.querySelector('.price ins .money')||box.querySelector('.price .money');
    return m?m.textContent.trim():'';
  }

  function habiller(btn){
    if(!btn)return;
    var label=btn.querySelector('.single-add-to-cart-button--text');
    if(!label)return;
    if(!btn.querySelector('.lulu-atc__ico')){
      var i=document.createElement('span');
      i.className='lulu-atc__ico'; i.innerHTML=CART;
      btn.insertBefore(i,label);
    }
    var p=btn.querySelector('.lulu-atc__price');
    if(!p){ p=document.createElement('span'); p.className='lulu-atc__price'; label.after(p); }
    var v=prixCourant();
    if(p.textContent!==v) p.textContent=v;
  }

  function poser(){
    /* le thème rend DEUX boutons : celui du formulaire et celui de la barre collante */
    document.querySelectorAll('button[name="add"]').forEach(habiller);
  }

  function observer(){
    var box=document.querySelector('.product-price-container');
    if(box && !box.__luluObs){ box.__luluObs=1;
      new MutationObserver(function(){ poser(); }).observe(box,{childList:true,subtree:true,characterData:true}); }
    document.querySelectorAll('.add_to_cart_holder, .product-add-to-cart-sticky').forEach(function(h){
      if(h.__luluObs)return; h.__luluObs=1;
      new MutationObserver(function(){ poser(); }).observe(h,{childList:true,subtree:true});
    });
  }

  function boot(){ poser(); observer(); setTimeout(function(){poser();observer();},900); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('variant:change',boot);
})();